export default __webpack_public_path__ + "static/media/cloud-desktop-premium-block1.01245120.png";